import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';
import { programasApi } from '../api/programas.js';
import { VazioQueEnsina } from '../componentes/transversais/VazioQueEnsina.js';

export function Programas() {
  const { data: programas, isLoading } = useQuery({ queryKey: ['programas'], queryFn: programasApi.listar });

  return (
    <div className="flex flex-col gap-6 p-8">
      <h1 className="text-xl font-semibold text-ink">Programas</h1>

      {isLoading && <p className="text-sm text-grafite">Carregando…</p>}

      {!isLoading && (!programas || programas.length === 0) && (
        <VazioQueEnsina explicacao="Nenhum programa criado. Programas agrupam projetos com dependências entre si e benefícios compartilhados." />
      )}

      {programas && programas.length > 0 && (
        <ul className="flex flex-col gap-2">
          {programas.map((programa) => (
            <li key={programa.id}>
              <Link to={`/programas/${programa.id}`} className="block rounded border border-borda bg-superficie px-4 py-3 hover:border-aco">
                <p className="text-sm text-ink">{programa.nome}</p>
                <p className="fonte-mono text-xs text-grafite">
                  {programa.estado} · responsável {programa.responsavel}
                </p>
              </Link>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
}
